import React, { useState, useRef, useCallback } from 'react';
import {
  Box,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  IconButton,
  VStack,
  Text,
  useToast,
  Tooltip,
  Alert,
  AlertIcon,
  Center,
  useDisclosure,
  Flex,
  useBreakpointValue,
  Spinner,
  Stack,
  HStack
} from '@chakra-ui/react';
import { CloseIcon, EditIcon} from '@chakra-ui/icons';
import { isLocalhost, removePort } from '../services/utils';
import { react_api } from '../config';
import SpinnerXL from './SpinnerXL';

// Stato globale per i tabs (puoi usare Context o uno state manager)
let globalTabs = [];
let globalSetTabs = null;
let globalToast = null;
let globalSetActiveTab = null;




export const pulisciTab = ()=> {
    globalSetTabs([]);
}

// Funzione esportata per aggiungere un nuovo tab
export const addNewTab = (tabData) => {
  const { name, url, description = 'Nessuna descrizione', isHome = false } = tabData;

  if (!url?.trim()) {
    if (globalToast) {
      globalToast({
        title: "URL richiesto",
        description: "Inserisci un URL valido",
        status: "warning",
        duration: 3000,
      });
    }
    return null;
  }

  if (!name?.trim()) {
    if (globalToast) {
      globalToast({
        title: "Nome richiesto",
        description: "Inserisci un nome per il tab",
        status: "warning",
        duration: 3000,
      });
    }
    return null;
  }

  // Se è un tab Home, verifica che non esista già
  if (isHome) {
    const homeTabExists = globalTabs.some(tab => tab.isHome);
    if (homeTabExists) {
      if (globalToast) {
        globalToast({
          title: "Tab Home già esistente",
          description: "È possibile avere solo un tab Home",
          status: "warning",
          duration: 3000,
        });
      }
      return null;
    }
  }

   let tabCheck = globalTabs.find(tab => tab.name === name);
   if(tabCheck != null  && tabCheck.name != null  && tabCheck.name=== "Home") {
    return
  }


  // Genera nome univoco
  const generateUniqueName = (baseName) => {
    const existingNames = globalTabs.map(tab => tab.name.toLowerCase());
    const baseNameLower = baseName.toLowerCase();
    
    if (!existingNames.includes(baseNameLower)) {
      return baseName;
    }
    
    let maxNumber = 0;
    const pattern = new RegExp(`^${baseNameLower.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\s*(\\d{2})?$`);
    
    existingNames.forEach(name => {
      const match = name.match(pattern);
      if (match) {
        if (match[1]) {
          const num = parseInt(match[1], 10);
          maxNumber = Math.max(maxNumber, num);
        } else {
          maxNumber = Math.max(maxNumber, 0);
        }
      }
    });
    
    const nextNumber = (maxNumber + 1).toString().padStart(2, '0');
    return `${baseName} ${nextNumber}`;
  };

  // Per il tab Home, non applicare la logica di nome univoco
  const uniqueName = isHome ? name.trim() : generateUniqueName(name.trim());

  const newTab = {
    id: Date.now(),
    name: uniqueName,
    description: description.trim() || 'Nessuna descrizione',
    url: url.trim(),
    savedState: null,
    isEditingName: false,
    isEditingDescription: false,
    isLoading: true,
    isHome: isHome // Aggiungi flag per identificare il tab Home
  };

  let newTabIndex = globalTabs.length;


 
 

  if (globalSetTabs) {
    globalSetTabs(prev => [...prev, newTab]);
  }
   console.log(globalTabs)

  // Switch to the new tab
  if (globalSetActiveTab) {
    globalSetActiveTab(newTabIndex);
  }

  // if (globalToast) {
  //   globalToast({
  //     title: "Tab aggiunto",
  //     description: `${uniqueName} è stato aggiunto`,
  //     status: "success",
  //     duration: 3000,
  //   });
  // }
  
  return newTab;
};

// Componente per visualizzare la descrizione con puntini espandibili
function DescriptionDisplay({ description, onEdit, isMobile }) {
  const [isExpanded, setIsExpanded] = useState(false);
  const maxLength = isMobile ? 50 : 80;
  const needsTruncation = description.length > maxLength;
  
  const displayText = needsTruncation && !isExpanded 
    ? description.slice(0, maxLength) 
    : description;

  return (
    <Flex gap={2} align="center" w="full" maxW="400px">
      <Text 
        fontSize={{ base: "xs", md: "sm" }} 
        color="gray.600"
        flex={1}
        textAlign={{ base: "center", md: "left" }}
        cursor={needsTruncation ? "pointer" : "default"}
        onClick={needsTruncation ? () => setIsExpanded(!isExpanded) : undefined}
        _hover={needsTruncation ? { color: "gray.800" } : {}}
        transition="color 0.2s"
      >
        {displayText}
        {needsTruncation && !isExpanded && (
          <Text as="span" color="blue.500" ml={1}>
            ...
          </Text>
        )}
      </Text>
      <IconButton
        size="xs"
        icon={<EditIcon />}
        variant="ghost"
        onClick={onEdit}
      />
    </Flex>
  );
}

// Componente per il loading spinner
function LoadingSpinner({ tabName }) {
  return (
    <Box 
      position="absolute" 
      top="0" 
      left="0" 
      right="0" 
      bottom="0" 
      bg="gray.50" 
      zIndex={10}
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <VStack spacing={4}>
        <Spinner size="xl" color="blue.500" thickness="4px" />
        <Stack spacing={2} align="center">
          <Text fontSize="lg" fontWeight="semibold" color="gray.700">
            Caricamento in corso...
          </Text>
          <Text fontSize="sm" color="gray.500">
            {tabName}
          </Text>
        </Stack>
      </VStack>
    </Box>
  );
}

function IframeTabsManager() {
  const [activeTab, setActiveTab] = useState(0);
  const [tabs, setTabs] = useState([]);
  
  const [newTabUrl, setNewTabUrl] = useState('');
  const [newTabName, setNewTabName] = useState('');
  const [newTabDescription, setNewTabDescription] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [showSearchResults, setShowSearchResults] = useState(false);
  const [isControlsCollapsed, setIsControlsCollapsed] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useToast();
  const iframeRefs = useRef({});
  const tabListRef = useRef(null);

  // Scroll per rendere visibile il tab attivo
  const scrollToActiveTab = useCallback(() => {
    if (!tabListRef.current) return;
    
    // Trova il tab attivo
    const activeTabElement = tabListRef.current.querySelector(`[data-index="${activeTab}"]`);
    if (!activeTabElement) return;

    // Calcola la posizione per centrare il tab o mostrarlo completamente
    const container = tabListRef.current;
    const tabRect = activeTabElement.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();
    
    // Se il tab è fuori dalla vista a destra
    if (tabRect.right > containerRect.right) {
      const scrollAmount = tabRect.right - containerRect.right + 20; // 20px di padding
      container.scrollLeft += scrollAmount;
    }
    // Se il tab è fuori dalla vista a sinistra
    else if (tabRect.left < containerRect.left) {
      const scrollAmount = containerRect.left - tabRect.left + 20; // 20px di padding
      container.scrollLeft -= scrollAmount;
    }
  }, [activeTab]);

  // Effetto per scrollare quando cambia il tab attivo
  React.useEffect(() => {
    const timeoutId = setTimeout(() => {
      scrollToActiveTab();
    }, 100); // Piccolo delay per assicurarsi che il DOM sia aggiornato

    return () => clearTimeout(timeoutId);
  }, [activeTab, scrollToActiveTab]);

  // Sincronizza lo stato globale
  React.useEffect(() => {
    globalTabs = tabs;
    globalSetTabs = setTabs;
    globalToast = toast;
    globalSetActiveTab = setActiveTab;
  }, [tabs, toast]);

  // Inizializza il tab Home solo se non esiste già
  React.useEffect(() => {
    // Controlla se esiste già un tab Home prima di crearlo
    const homeTabExists = tabs.some(tab => tab.isHome);
    if (!homeTabExists) {
      addNewTab({ 
        name: "Home", 
        url: isLocalhost() ? 
          `http://localhost:3000/home?hideHeader=true&hideNavbar=true` : 
          `${removePort(react_api)}/home?hideHeader=true&hideNavbar=true`, 
        description: "", 
        isHome: true 
      });
    }
  }, []);

  // Responsive breakpoints
  const isMobile = useBreakpointValue({ base: true, md: false });
  const isTablet = useBreakpointValue({ base: false, md: true, lg: false });
  const tabDirection = useBreakpointValue({ base: 'horizontal', lg: 'horizontal' });

  // Gestisce il caricamento dell'iframe
  const handleIframeLoad = useCallback((tabId) => {
    setTabs(prev => prev.map(t => 
      t.id === tabId ? { ...t, isLoading: false } : t
    ));
  }, []);

  // Gestisce l'errore di caricamento dell'iframe
  const handleIframeError = useCallback((tabId) => {
    setTabs(prev => prev.map(t => 
      t.id === tabId ? { ...t, isLoading: false } : t
    ));
    
    toast({
      title: "Errore di caricamento",
      description: "Impossibile caricare il contenuto del tab",
      status: "error",
      duration: 3000,
    });
  }, [toast]);

  // Salva lo stato dell'iframe
  const saveIframeState = useCallback(async (tabId) => {
    const iframe = iframeRefs.current[tabId];
    if (!iframe) return null;

    try {
      const state = {
        currentUrl: iframe.src,
        timestamp: Date.now(),
        originalUrl: iframe.getAttribute('data-original-url') || iframe.src
      };

      try {
        const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;
        if (iframeDoc) {
          state.scrollPosition = {
            x: iframeDoc.documentElement.scrollLeft || iframeDoc.body.scrollLeft,
            y: iframeDoc.documentElement.scrollTop || iframeDoc.body.scrollTop
          };
          state.documentTitle = iframeDoc.title;
          state.currentLocation = iframeDoc.location.href;
        }
      } catch (e) {
        console.log('Cannot access iframe content due to CORS policy');
      }

      setTabs(prev => prev.map(t => 
        t.id === tabId ? { ...t, savedState: state } : t
      ));

      return state;
    } catch (error) {
      console.error('Error saving iframe state:', error);
      return null;
    }
  }, []);

  // Ripristina lo stato dell'iframe
  const restoreIframeState = useCallback((iframe, savedState) => {
    if (!iframe || !savedState) return;

    if (savedState.currentUrl && iframe.src !== savedState.currentUrl) {
      iframe.src = savedState.currentUrl;
    }

    if (savedState.scrollPosition) {
      const restoreScroll = () => {
        try {
          const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;
          if (iframeDoc) {
            iframeDoc.documentElement.scrollLeft = savedState.scrollPosition.x;
            iframeDoc.documentElement.scrollTop = savedState.scrollPosition.y;
          }
        } catch (e) {
          console.log('Cannot restore scroll position due to CORS policy');
        }
      };

      iframe.onload = () => {
        setTimeout(restoreScroll, 100);
      };
    }
  }, []);

  // Chiudi tab
  const closeTab = (tabId) => {
    // Trova il tab da chiudere
    const tabToClose = tabs.find(t => t.id === tabId);
    
    // Impedisci la chiusura del tab Home
    if (tabToClose?.isHome) {
      toast({
        title: "Impossibile chiudere",
        description: "Il tab Home non può essere chiuso",
        status: "warning",
        duration: 3000,
      });
      return;
    }

    setTabs(prev => prev.filter(t => t.id !== tabId));

    const remainingTabs = tabs.filter(t => t.id !== tabId);
    if (remainingTabs.length > 0 && activeTab >= remainingTabs.length) {
      setActiveTab(0);
    }
  };

  // Chiude il modal e resetta i campi
  const handleCloseModal = () => {
    setNewTabUrl('');
    setNewTabName('');
    setNewTabDescription('');
    onClose();
  };

  // Auto-save periodico dello stato del tab attivo
  React.useEffect(() => {
    const interval = setInterval(() => {
      if (tabs.length > 0 && activeTab < tabs.length) {
        const activeTabId = tabs[activeTab]?.id;
        if (activeTabId) {
          saveIframeState(activeTabId);
        }
      }
    }, 30000);

    return () => clearInterval(interval);
  }, [tabs, activeTab, saveIframeState]);

  // Ottieni il tab attivo
  const currentTab = tabs[activeTab];

  return (
    <Box h="100vh" display="flex" flexDirection="column" p={1}>
      <VStack spacing={{ base: 2, md: 4 }} align="stretch" flex={1}>
        {/* Tabs */}
        {tabs.length > 0 ? (
          <Tabs 
            index={activeTab} 
            onChange={setActiveTab} 
            orientation={tabDirection}
            flex={1}
            display="flex"
            flexDirection="column"
            variant="unstyled"
          >
            <TabList 
              ref={tabListRef}
              flexShrink={0}
              overflowX="auto"
              overflowY="hidden"
              px={2}
            >
              {tabs.map((tab, index) => (
                <Tab 
                  key={tab.id}
                  position="relative"
                  px={{ base: 3, md: 4 }}
                  py={2}
                  whiteSpace="nowrap"
                  data-index={index}
                  color="#006778"
                  borderTopLeftRadius="lg"
                  borderTopRightRadius="lg"
                  borderBottomRadius="none"
                  _selected={{ bg: "#f6f3ec", color: "#006778" }}
                >
                  <HStack spacing={3} align="center">
                    <Text
                      fontWeight="semibold"
                      fontSize={{ base: "xs", md: "sm" }}
                      noOfLines={1}
                    >
                      {tab.name}
                    </Text>
                    {tab.isLoading && <Spinner size="xs" color="currentColor" />}
                    {!tab.isHome && ( // Mostra il pulsante di chiusura solo se non è il tab Home
                      <Tooltip label="Chiudi tab">
                        <IconButton
                          icon={<CloseIcon boxSize={3} />}
                          size="2xs"
                          variant="ghost"
                          color="red"
                          onClick={(e) => {
                            e.stopPropagation();
                            closeTab(tab.id);
                          }}
                          aria-label="Close tab"
                        />
                      </Tooltip>
                    )}
                  </HStack>
                </Tab>
              ))}
            </TabList>

            <TabPanels flex={1} display="flex" flexDirection="column">
              {tabs.map((tab) => (
                <TabPanel key={tab.id} p={0} flex={1} display="flex" flexDirection="column">
                  <Box 
                    flex={1} 
                    border="1px solid" 
                    borderColor="gray.200" 
                    borderRadius="md"
                    overflow="hidden"
                    minH={{ base: "400px", md: "500px" }}
                    position="relative"
                  >
                    {tab.isLoading && (
                      <SpinnerXL/>
                    )}
                    <iframe
                      ref={el => {
                        iframeRefs.current[tab.id] = el;
                        if (el && tab.savedState) {
                          restoreIframeState(el, tab.savedState);
                        }
                      }}
                      src={tab.savedState?.currentUrl || tab.url}
                      width="100%"
                      height="100%"
                      frameBorder="0"
                      title={tab.name}
                      data-original-url={tab.url}
                      style={{ 
                        display: 'block',
                        opacity: tab.isLoading ? 0 : 1,
                        transition: 'opacity 0.3s ease'
                      }}
                      onLoad={() => handleIframeLoad(tab.id)}
                      onError={() => handleIframeError(tab.id)}
                    />
                  </Box>
                </TabPanel>
              ))}
            </TabPanels>
          </Tabs>
        ) : (
          <Center flex={1}>
            <Alert status="info" maxWidth="400px">
              <AlertIcon />
              <Box>
                <Text fontWeight="bold">Nessun tab disponibile</Text>
                <Text fontSize="sm">Aggiungi un nuovo tab per iniziare a navigare.</Text>
              </Box>
            </Alert>
          </Center>
        )}
      </VStack>
    </Box>
  );
}

export default IframeTabsManager;